export default __webpack_public_path__ + "static/media/video-thumbnail.cb689fa2.jpg";